import { fetchWrapper } from "../utils/fetch"
import { globalState } from "./global-state"

export interface ISummaryBoxState {
    corretoraImageBase64: string
    nome: string
    cpf: string

    seguradoraImageBase64?: string
    plano?: string
    vlrPremio?: number

}

export const downloadPdfCotacao = async () => {
    globalState.isLoading.set(true);

    await fetchWrapper("/api/pdf/cotacao", 
        null, 
        {
            isDownloadFile: true
        }
    );

    globalState.isLoading.set(false);
}